import styled from 'styled-components';
import { themeColor, themeFont } from '../../../theme/getters';

export const Container = styled.button`
  background: ${({ primary }) => themeColor(primary ? 'primary' : 'white')};
  color: ${({ primary }) => themeColor(primary ? 'white' : 'primary')};
  border: 1px solid ${({ primary }) => themeColor(primary ? 'primary' : 'middleGray')};
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
  padding: 9px 16px;
  border-radius: 30px;

  i {
    color: ${({ primary }) => primary && themeColor('white')};
  }
`;

export const Label = styled.span`
  font-family: ${themeFont('primary')};
  font-weight: normal;
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;
